import React from 'react'
import styled from 'styled-components'
import { type DiscountImageProps } from '../Types'
import ImageWrapper from './styled/ImageWrapper'
import Image from './SimpleImage'
import { SIZES } from '../../../constants'

const DiscountAmount = styled.div`
  background: #eb6500;
  color: #fff;
  font-size: 14px;
  font-weight: 900;
  height: 28px;
  left: 0;
  line-height: 28px;
  position: absolute;
  text-align: center;
  top: 0;
  width: 48px;
`

const VerticalImageWrapper = styled(ImageWrapper)`
  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    margin-right: 15px;
  }
  @media (min-width: ${SIZES.BREAKPOINT_MD}px) {
    margin-bottom: 10px;
  }
`

export default (props: DiscountImageProps) => {
  const {
    discount,
    image,
    imageClass,
    title
  } = props

  return (
    <VerticalImageWrapper>
      <Image src={image} alt={title} className={imageClass}/>
      {
        discount &&
        <DiscountAmount>
          -{ discount } %
        </DiscountAmount>
      }
    </VerticalImageWrapper>
  )
}
